import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import {
    IExif,
    IExifElement,
    TagValues,
    dump as exifDump,
    insert as exifInsert,
} from 'piexif-ts';

const degToDmsRational = (degFloat: number) => {
    const minFloat = (degFloat % 1) * 60;
    const secFloat = (minFloat % 1) * 60;
    let deg = Math.floor(degFloat);
    let min = Math.floor(minFloat);
    let sec = Math.round(secFloat * 100);

    deg = Math.abs(deg) * 1;
    min = Math.abs(min) * 1;
    sec = Math.abs(sec) * 1;

    return [
        [deg, 1],
        [min, 1],
        [sec, 100],
    ];
};

const getDateToGpsDateStamp = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are 0-based
    const day = date.getDate();
    return `${year}:${month.toString().padStart(2, '0')}:${day
        .toString()
        .padStart(2, '0')}`;
};

const getTimeToGpsTimeStamp = () => {
    const date = new Date();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return [
        [hours, 1],
        [minutes, 1],
        [seconds, 1],
    ];
};

const modifyImageExifData = async (dataURL: string) => {
    try {
        const gps: IExifElement = {};
        const platform = Capacitor.getPlatform();
        const permissions = await Geolocation.checkPermissions();
        if (platform !== 'web') {
            if (permissions.location === 'denied') {
                await Geolocation.requestPermissions({
                    permissions: ['location'],
                });
            }
        }

        const coordinates = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 10000,
        });
        gps[TagValues.GPSIFD.GPSLatitude] = degToDmsRational(
            coordinates.coords.latitude
        );
        gps[TagValues.GPSIFD.GPSLongitude] = degToDmsRational(
            coordinates.coords.longitude
        );
        gps[TagValues.GPSIFD.GPSLatitudeRef] =
            coordinates.coords.latitude >= 0 ? 'N' : 'S';
        gps[TagValues.GPSIFD.GPSLongitudeRef] =
            coordinates.coords.longitude >= 0 ? 'E' : 'W';

        gps[TagValues.GPSIFD.GPSDateStamp] = getDateToGpsDateStamp();
        gps[TagValues.GPSIFD.GPSTimeStamp] = getTimeToGpsTimeStamp();

        const exifObj: IExif = { GPS: gps };
        const exifStr = exifDump(exifObj);
        const imageEditedDataURL = exifInsert(exifStr, dataURL);
        return imageEditedDataURL;
    } catch (e) {
        console.log('Error on modifyImageExifData', e);
        throw e;
    }
};

export default modifyImageExifData;
